import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useTenant } from '../contexts/TenantContext'

export const usePlayers = (tournamentId, teamId = null) => {
  const { activeTenant } = useTenant()
  const [players, setPlayers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (tournamentId && activeTenant) {
      fetchPlayers()
    }
  }, [tournamentId, teamId, activeTenant])

  const fetchPlayers = async () => {
    try {
      let query = supabase
        .from('players')
        .select(`
          *,
          team:teams(id, name)
        `)
        .eq('tournament_id', tournamentId)
        .order('name')

      if (teamId) {
        query = query.eq('team_id', teamId)
      }

      const { data, error } = await query
      if (error) throw error
      setPlayers(data || [])
    } catch (err) {
      console.error('Error fetching players:', err)
    } finally {
      setLoading(false)
    }
  }

  const createPlayer = async (playerData) => {
    const { data, error } = await supabase
      .from('players')
      .insert([{
        ...playerData,
        tournament_id: tournamentId,
        tenant_id: activeTenant.id
      }])
      .select()
      .single()

    if (error) throw error
    setPlayers([...players, data])
    return data
  }

  const deletePlayer = async (playerId) => {
    const { error } = await supabase
      .from('players')
      .delete()
      .eq('id', playerId)

    if (error) throw error
    setPlayers(players.filter(p => p.id !== playerId))
  }

  const updatePlayer = async (playerId, updates) => {
    const { data, error } = await supabase
      .from('players')
      .update(updates)
      .eq('id', playerId)
      .select(`
        *,
        team:teams(id, name)
      `)
      .single()

    if (error) throw error
    setPlayers(players.map(p => p.id === playerId ? data : p))
    return data
  }

  return { players, loading, createPlayer, updatePlayer, deletePlayer, refetch: fetchPlayers }
}
